import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RedZoomModule } from 'ngx-red-zoom';

import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { AppHeaderComponent } from './app-header/app-header.component';
import { HomeComponent } from './home/home.component';
import { UsersComponent } from './users/users.component';
import { EditorModule } from '@tinymce/tinymce-angular';
import {SocialLoginModule, GoogleLoginProvider, FacebookLoginProvider, SocialAuthServiceConfig}from '@abacritt/angularx-social-login';
import { DndModule } from 'ngx-drag-drop';
import {
  FontAwesomeModule,
  FaIconLibrary,
} from '@fortawesome/angular-fontawesome';
import {
  faPlus,
  faPen,
  faCheck,
  faBan,
  faMinus,
  faShoppingCart,
  faTrash,
  faEnvelope,
  faCopy,
  faCog,
  faExchangeAlt,
  faArrowCircleLeft,
  faArrowCircleRight,
  faFilePdf,
  faFileWord,
  faFileExport,
  faPlay,
  faFastForward,
  faProjectDiagram,
  faFileArchive,
  faRobot
} from '@fortawesome/free-solid-svg-icons';
import { UserModalComponent } from './users/user-modal/user-modal.component';
import { LogoutModalComponent } from './auth/logout-modal/logout-modal.component';
import { CompetitionComponent } from './competition/competition/competition.component';
import { CompetionModalComponent } from './competition/competion-modal/competion-modal.component';
import { CompetitionThemeModalComponent } from './competition/competition-theme-modal/competition-theme-modal.component';
import { LoginInterceptor } from './login.interceptor';
import { InvitationModalComponent } from './competition/invitation-modal/invitation-modal.component';
import { AuthService } from './authentication/auth-service.service';
import { InvitationComponent } from './invitation/invitation.component';
import { RecoveryComponent } from './recovery/recovery.component';
import { CompetitionImagesComponent } from './competition-images/competition-images.component';
import { CompetitionVotesComponent } from './competition-votes/competition-votes.component';
import { ModalComponent } from './competition-images/modal/modal.component';
import { CommentModalComponent } from './competition-votes/comment-modal/comment-modal.component';
import { CompareModalComponent } from './competition-votes/compare-modal/compare-modal.component';
import { SliderModalComponent } from './slider-modal/slider-modal.component';
import { EntervoteModalComponent } from './competition-votes/entervote-modal/entervote-modal.component';
import { CompetitionResultComponent } from './competition-result/competition-result.component';
import { ResultModalComponent } from './competition-result/result-modal/result-modal.component';
import { CompetitionPresentationComponent } from './competition-presentation/competition-presentation.component';
import { ToastConfigComponent } from "./toast/toast-config.component";
import { ToastComponent } from "./toast/toast.component";
import { SubCompetitionComponent } from './competition-result/sub-competition/sub-competition.component';
import { ImagesResultComponent } from './competition-result/images-result/images-result.component';
import { YesNoModalComponent } from './shared/yes-no-modal/yes-no-modal.component';
import { VideoplayerComponent } from './help/videoplayer/videoplayer.component';
import { TitleModalComponent } from './competition-images/title-modal/title-modal.component';
import { FooterComponent } from './footer/footer.component';
import { FooterModalComponent } from './footer/footer-modal/footer-modal.component';
import { MarkdownModule, provideMarkdown } from 'ngx-markdown';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsComponent } from './terms/terms.component';
import { DeletionComponent } from './deletion/deletion.component';
import { CommonModule } from '@angular/common';
import { RegisterComponent } from './about/register/register.component';
import { UploadComponent } from './about/upload/upload.component';
import { VoteComponent } from './about/vote/vote.component';
import { AbouttComponent } from './about/about.component';
import { AboutComponent } from './about/about/about.component';

@NgModule({ declarations: [
        AppComponent,
        AppHeaderComponent,
        HomeComponent,
        UsersComponent,
        UserModalComponent,
        CompetitionComponent,
        CompetionModalComponent,
        CompetitionThemeModalComponent,
        InvitationModalComponent,
        InvitationComponent,
        RecoveryComponent,
        CompetitionImagesComponent,
        CompetitionVotesComponent,
        ModalComponent,
        CommentModalComponent,
        CompareModalComponent,
        SliderModalComponent,
        EntervoteModalComponent,
        CompetitionResultComponent,
        ResultModalComponent,
        LogoutModalComponent,
        CompetitionPresentationComponent,
        ToastConfigComponent,
        ToastComponent,
        SubCompetitionComponent,
        ImagesResultComponent,
        YesNoModalComponent,
        VideoplayerComponent,
        TitleModalComponent,
        FooterComponent,
        FooterModalComponent,
        PrivacyPolicyComponent,
        TermsComponent,
        DeletionComponent,
        CompetionModalComponent,
        RegisterComponent,
        UploadComponent,
        AbouttComponent,
        AboutComponent,
        VoteComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        CommonModule,
        NgbModule,
        FormsModule,
        FontAwesomeModule,
        DndModule,
        RedZoomModule,
        EditorModule,
        SocialLoginModule,
        MarkdownModule,
        TabsModule.forRoot()], providers: [
        AuthService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LoginInterceptor,
            multi: true,
        },
        {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                      id: GoogleLoginProvider.PROVIDER_ID,
                      provider: new GoogleLoginProvider(
                        '910979243637-q9av1v6k3snnmoj9lcqoodlgvr7dseeh.apps.googleusercontent.com'
                      )
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('1291290449389181')
                    }
                ],
                onError: (err) => {
                    console.error(err);
                }
            } as SocialAuthServiceConfig,
        },
        provideMarkdown(),
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor(readonly library: FaIconLibrary) {
    library.addIconPacks([
      faPlus,
      faPen,
      faCheck,
      faBan,
      faMinus,
      faShoppingCart,
      faTrash,
      faEnvelope,
      faCopy,
      faCog,
      faExchangeAlt,
      faArrowCircleLeft,
      faArrowCircleRight,
      faFilePdf,
      faFileWord,
      faFileExport,
      faPlay,
      faFastForward,
      faProjectDiagram,
      faFileArchive,
      faRobot
    ] as any);
  }
}
